import { render } from "./iconFeria.vue?vue&type=template&id=4c117838&scoped=true"
import script from "./iconFeria.vue?vue&type=script&lang=js"
export * from "./iconFeria.vue?vue&type=script&lang=js"

import "./iconFeria.vue?vue&type=style&index=0&id=4c117838&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4c117838"

export default script